import { getHeaders } from "../utils";

export async function APIGetUser(userId) {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);


    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };

    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;

    const response = await fetch(`${apiUrl}/user/1.0/user/${userId}`, requestOptions);
    const responseObject = await response.json();
    const users = responseObject.data;

    if (users.length > 0) {
      return await users[0];
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export async function APICreateUser(cognitoUser) {
  const userData = {
    id: cognitoUser.attributes.sub,
    companyId: cognitoUser.attributes['custom:companyId'],
    name: `${cognitoUser.attributes.given_name ? cognitoUser.attributes.given_name : ''} ${
      cognitoUser.attributes.family_name ? cognitoUser.attributes.family_name : ''
    }`,
    email: cognitoUser.attributes.email,
    role: cognitoUser.attributes['custom:role'],
    status: 'active',
    details: {
      given_name: cognitoUser.attributes.given_name ? cognitoUser.attributes.given_name : '',
      family_name: cognitoUser.attributes.family_name
        ? cognitoUser.attributes.family_name
        : '',
      phone: '',
      address: {
        street: '',
        zipCode: '',
        city: '',
        country: 'DE',
      },
    },
  };

  const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(userData),
    redirect: 'follow',
  };

  try {
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/user/1.0/user`, requestOptions);
    const responseObject = await response.json();
    const user = responseObject.data;

    if (user) {
      return user;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export async function APIPutUserData(userData) {
  const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

  const requestOptions = {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify(userData),
    redirect: 'follow',
  };

  try {
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(
      `${apiUrl}/user/1.0/user/${userData.id}`,
      requestOptions,
    );

    return response.status === 200;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIPutUserEmail = async (userId, email, username) => {
  const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

  const requestOptions = {
    method: 'PUT',
    headers: headers,
    redirect: 'follow',
    body: JSON.stringify({ email, username }),
  };

  try {
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(
      `${apiUrl}/user/1.0/user/${userId}/email`,
      requestOptions,
    );

    if (response.status === 200) {
      return {error: false, message: 'Email updated successfully'};
    } else if (response.status === 401) {
      return {error: true, message: 'Diese E-Mail-Adresse ist bereits vergeben.'};
    } else {
      return {error: true, message: 'Fehler beim Aktualisieren der E-Mail-Adresse.'};
    }
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIInviteNewUserToCompany = async (user) => {
  const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(user),
    redirect: 'follow',
  };

  try {
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/user/1.0/invite`, requestOptions);
    const responseObject = await response.json();
    
    return responseObject.data;

  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIUpdateLastLoginTime = async (userId) => {
  const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

  const requestOptions = {
    method: 'PUT',
    headers: headers,
    redirect: 'follow',
  };

  try {
    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/user/1.0/user/${userId}/login`, requestOptions);

    return response.status === 200;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIGetMyCompanies = async (userId) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };

    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/user/1.0/companies/${userId}`, requestOptions);
    const responseObject = await response.json();
    const companies = responseObject.data;

    if (companies?.length > 0) {
      return await companies;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIChangeMyCompany = async (userId, companyId) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'PUT',
      headers: headers,
      redirect: 'follow',
    };

    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/user/1.0/companies/${userId}/change/${companyId}`, requestOptions);

    return response.status === 200;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIGetUserAccess = async (userId) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };

    const apiUrl =
      process.env.REACT_APP_MODE === 'PROD'
        ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
        : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/user/1.0/companies/${userId}/access`, requestOptions);
    const responseObject = await response.json();
    const access = responseObject.data;

    if (access.length > 0) {
      return await access;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}